import React from 'react'
import {GlobalProvider} from '../../shared/global_context'
import PropTypes from 'prop-types'
import configureStore from '../../shared/configure_store'
import LeaderboardV2Container from './leaderboardV2_container'
import leaderboardV2RootReducer from '../reducers/leaderboardV2_root_reducer'
import { createLeaderboardV2State } from '../reducers/leaderboardV2_reducer'
import { loadFavorites } from '../actions/helpers/local_storage_helper'
import { NotificationContainer } from 'react-notifications'
import { SITE_CONTEXTS } from '../constants'

const LeaderboardV2Root = (initialState) => {

  const state = {
    leaderboardV2: {
      // Defaults first: the preloaded state bypasses the reducer's own
      // initialState, so keys the backend omits must be filled in here.
      ...createLeaderboardV2State(),
      ...initialState,
      eventsList: {},
      favoritesByEvent: loadFavorites(),
    },

    event: {},

    details: {},
  }

  const store = configureStore(leaderboardV2RootReducer, state)

  // The manager site already mounts a NotificationContainer via the navigator
  // chrome; add one only for public/widget contexts so the share "link copied"
  // toast has somewhere to render.
  const isManagerSite = initialState.context === SITE_CONTEXTS.MANAGER_SITE

  return (
    <GlobalProvider store={store}>
      <LeaderboardV2Container/>
      {!isManagerSite && <NotificationContainer/>}
    </GlobalProvider>
  )
}

LeaderboardV2Root.propTypes = {
  initialState: PropTypes.any,
}

export default LeaderboardV2Root
